export enum KullaniciTip {
  BIREYSEL = 0,
  KURUMSAL = 1,
  TAPU = 2,
}
